import React from "react";
import ReactDOM from "react-dom"; //basicaly created as a tree of objects 
//Using DOM, JavaScript can perform multiple tasks
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom"; 
//Here, you need to import line: import { Route, Link, BrowserRouter as Router } from 'react-router-dom' which helps us to implement the Routing.
import "@fortawesome/fontawesome-free/css/all.min.css";
//Here, you need to import line: import "@fortawesome/fontawesome-free/css/all.min.css"; which helps us to implement the font css.
import "assets/styles/tailwind.css";
import "assets/styles/tailwind.min.css";


//Here, you need to import tailwind css which helps us to implement the tailwind css 

// layouts



// views without layouts
import Index from "views/Index.js";
import Landing from "views/About.js";
import Careers from "views/Career.js";
//Services 
import ReactNative from "views/ReactNative.js";
import Python from "views/Python.js";
import PHP from "views/PHP.js";
import Wordpress from "views/Wordpress.js";
import Node from "views/Node.js";
import Ionic from "views/Ionic.js";
import Laravel from "views/Laravel.js";
import CI from "views/CI.js";
import MobileApp from "views/MobileApp.js";
import Ios from "views/Ios.js";
import Android from "views/Android.js";
import Angular from "views/Angular.js";
import Flutter from "views/Flutter.js";
import ReactJS from "views/Reactjs.js";


//Here We use ReactDom for creating object 
ReactDOM.render(
  <BrowserRouter>
    <Switch>
      {/* add routes with layouts */}
    
      {/* Main Menu */}
      <Route path="/" exact component={Index} />
      <Route path="/About" exact component={Landing} />
      {/*Serviece*/}
      <Route path="/Flutter" component={Flutter} />
      <Route path="/Reactjs" component={ReactJS}/>     
      <Route path="/ReactNative" exact component={ReactNative} />
      <Route path="/Angular" exact component={Angular} />
      <Route path="/Android" exact component={Android} />
      <Route path="/Ios" exact component={Ios} />
      <Route path="/Ionic" exact component={Ionic} />
      <Route path="/PHP" exact component={PHP} />
      <Route path="/Laravel" exact component={Laravel} />
      <Route path="/CI" exact component={CI} />
      <Route path="/Wordpress" exact component={Wordpress} />
      <Route path="/Node" exact component={Node} />
      <Route path="/Python" exact component={Python} />
      <Route path="/MobileApp" exact component={MobileApp} />
     {/* Main Pages */}
     {/* <Route path="/Blog" component={Blog}/> */}
     <Route path="/Career" component={Careers}/>      
      <Redirect from="*" to="/" />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
